/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useRef, useEffect } from 'react';
import { Form } from 'semantic-ui-react';
import { string, shape } from 'prop-types';
import SignaturePad from 'react-signature-pad-wrapper';
import { getIn } from 'formik';

import style from './Signature.less';

const Signature = props => {
  const {
    label,
    form: { touched, errors, setFieldValue },
    field: { name, value },
  } = props;
  const ref = useRef();

  useEffect(() => {
    ref.current.fromDataURL(value);
  }, [ref, value]);

  const onClear = () => {
    ref.current.clear();
    setFieldValue(name, '');
  };

  const handleOnEnd = () => {
    const image = ref.current.toDataURL('image/png');
    setFieldValue(name, image);
  };

  const touch = getIn(touched, name);
  const errorText = getIn(errors, name);

  return (
    <Form.Field>
      <div className={style.header}>
        {label && <label className={style.label}>{label}</label>}
        <div onClick={onClear} className={style.action}>
          CLEAR
        </div>
      </div>
      <div className={style.content}>
        <SignaturePad
          options={{
            penColor: 'black',
            onEnd: handleOnEnd,
          }}
          ref={ref}
        />
      </div>
      {touch && errorText && <div className={style.error}>{errorText}</div>}
    </Form.Field>
  );
};

Signature.propTypes = {
  form: shape({}).isRequired,
  field: shape({}).isRequired,
  label: string,
};

Signature.defaultProps = {
  label: '',
};

export default Signature;
